<template>
  <transition name="pa-simple-fade">
    <div class="pa-connection-no-message-view" v-if="isOpen">
      <div class="text-circle">初</div>
      <p>まだ投稿はありません。</p>
    </div>
  </transition>
</template>

<script>
export default {
  props : {
    isOpen : {
      default: false
    }
  }
}
</script>

<style lang="scss">
.pa-connection-no-message-view{
  padding-bottom:1rem;

  p{
    color:#B0814A;
    text-align: center;
    font-size:1.1rem;

    &:first-child{
      font-size:2.4rem;
    }

    &:last-child{
      padding-left:.5rem;
    }
  }

  .text-circle{
    margin:1rem auto .5rem;
    width:4rem;
    border-radius: 50%;
    height:4rem;
    border:4.5px solid #B0814A;
    color:#B0814A;
    text-align: center;
    line-height: 3.9rem;
    font-size:3rem;
  }
}
</style>